import DownloadsConfiguratorPreviewPane from './DownloadsConfiguratorPreviewPane';

export default DownloadsConfiguratorPreviewPane;
